import React, { useState, useEffect } from "react";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateLocation } from "../../../../../redux/customer/customerSlice";
import PopupCard from "../../../../../components/Cards/PopupCard/PopupCard";
import { states } from "../../../../../utils/schema/states";
import axios from "axios";
const EditLocation = ({ onOpen, onClose, userId }) => {
  const dispatch = useDispatch();
  const [cities, setCities] = useState([]);
  const [successPopup, setSuccessPopup] = useState({
    visible: false,
    message: "",
  });
  //---------Selected location for edit-------
  const { customerAddedLocation: locationList, selectedLocation: selectedLocationId } = useSelector(
    (state) => state.customer,
  );
  const selectedLocation = (locationList || []).find(
    (loc) => loc._id === selectedLocationId,
  );
  const [formData, setFormData] = useState({
    name: "",
    location_type: "",
    country: "",
    state: "",
    city: "",
    address: "",
    status: "",
  });
  useEffect(() => {
    if (selectedLocation) {
      const matchedState = states.find(
        (s) => s.name === selectedLocation.state,
      );

      setFormData({
        name: selectedLocation.name || "",
        location_type: selectedLocation.location_type || "",
        country: selectedLocation.country || "",
        state: selectedLocation.state || "",
        stateCode: matchedState?.code || "",
        city: selectedLocation.city || "",
        address: selectedLocation.address || "",
        status: selectedLocation.isActive ? "Active" : "Inactive",
      });

      if (matchedState?.code) {
        fetchCities(matchedState.code);
      }
    }
  }, [selectedLocation]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //---------GET CITIES
  const fetchCities = async (stateCode) => {
    try {
      if (!stateCode) {
        setCities([]);
        return;
      }
      const res = await axios.get(
        `https://api.countrystatecity.in/v1/countries/IN/states/${stateCode}/cities`,
        {
          headers: {
            "X-CSCAPI-KEY":
              "0ae5a8283890022255b0058d88f4397ecde12b3253eae7c2af2ef157c23f108b",
          },
        },
      );

      setCities(res.data);
    } catch (err) {
      console.error("City fetch failed", err);
      setCities([]);
    }
  };
  //----HANDLE SAVE-----
  const handleSave = async () => {
    const payload = {
      name: formData.name,
      location_type: formData.location_type,
      country: formData.country,
      state: formData.state,
      city: formData.city,
      address: formData.address,
      isActive: formData.status === "Active",
    };

    try {
      const res = await dispatch(
        updateLocation({
          id: selectedLocationId,
          payload,
        }),
      ).unwrap();

      setSuccessPopup({
        visible: true,
        message: res.message,
      });

      setTimeout(() => {
        setSuccessPopup({
          visible: false,
          message: "Location updated sucessfully",
        });
        onClose();
      }, 2000);
    } catch (err) {
      console.error("Update failed:", err);
    }
  };
  return (
    <div>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div className="p-3">
          {/* FORM GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Location Name */}
            <div>
              <label className="text-sm text-gray-700">Location Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
              />
            </div>

            {/* Location Type */}
            <div>
              <label className="text-sm text-gray-700">Location Type</label>
              <select
                className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
                value={formData.location_type}
                onChange={(e) =>
                  setFormData({ ...formData, location_type: e.target.value })
                }
              >
                <option value="">Select Type</option>
                <option>Warehouse</option>
                <option>Manufacturing</option>
                <option>Office</option>
              </select>
            </div>

            {/* Country */}
            <div>
              <label className="text-sm text-gray-700">Country</label>
              <input
                type="text"
                value={formData.country}
                onChange={(e) =>
                  setFormData({ ...formData, country: e.target.value })
                }
                className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
              />
            </div>

            {/* State */}
            <div>
              <label className="text-sm text-gray-700">State</label>
              <select
                name="state"
                value={formData.stateCode}
                onChange={(e) => {
                  const selectedState = states.find(
                    (s) => s.code === e.target.value,
                  );

                  setFormData((prev) => ({
                    ...prev,
                    state: selectedState?.name || "",
                    stateCode: selectedState?.code || "",
                    city: "",
                  }));

                  fetchCities(e.target.value);
                }}
                className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1" // ✅ ADD THIS
              >
                <option value="">Select State</option>

                {states.map((state) => (
                  <option key={state.id} value={state.code}>
                    {state.name}
                  </option>
                ))}
              </select>
            </div>

            {/* City */}
            <div>
              <label className="text-sm text-gray-700">City</label>
              <select
                name="city"
                value={formData.city}
                onChange={handleChange}
                className="w-full mt-1 border border-[#3BA2B959] rounded-md px-3 py-2 outline-none"
              >
                <option value="">Select City</option>

                {cities.map((city, index) => (
                  <option key={index} value={city.name}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Address */}
            <div>
              <label className="text-sm text-gray-700">Address</label>
              <input
                type="text"
                value={formData.address}
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
                className="w-full border border-[#8EC5D6] rounded-md p-2 mt-1"
              />
            </div>
          </div>

          {/* ADD locations
        <div className="mt-6">
          <h3 className="text-[#06513D] font-semibold mb-3">Add Department</h3>
 
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { label: "Sales", key: "sales" },
              { label: "Transport", key: "transport" },
              { label: "Operations", key: "operations" },
              { label: "Marketing", key: "marketing" },
              { label: "Admin", key: "admin" },
              { label: "IT", key: "it" },
            ].map((dept) => (
              <label
                key={dept.key}
                className="flex items-center gap-2 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={locations[dept.key]}
                  onChange={() => handleCheck(dept.key)}
                  className="w-4 h-4 accent-[#06513D]"
                />
                {dept.label}
              </label>
            ))}
          </div>
        </div> */}

          {/* STATUS */}
          <div className="mt-6">
            <label className="text-sm text-gray-700">
              Status <span className="text-red-500">*</span>
            </label>
            <br />
            <select
              value={formData.status}
              onChange={(e) =>
                setFormData({ ...formData, status: e.target.value })
              }
              className="w-full md:w-1/2 border border-[#8EC5D6] rounded-md p-2 mt-1"
            >
              <option value="">Select Status</option>
              <option>Active</option>
              <option>Inactive</option>
            </select>
          </div>

          {/* BUTTONS */}
          <div className="flex justify-center gap-4 mt-8">
            <button
              onClick={onClose}
              className="px-6 py-2 border border-[#06513D] text-[#06513D] rounded-md"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-6 py-2 bg-[#06513D] text-white rounded-md"
            >
              Save
            </button>
          </div>
        </div>
      </DailogBox>
      {successPopup.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type="success"
            title="Success"
            message={successPopup.message}
          />
        </div>
      )}
    </div>
  );
};

export default EditLocation;
